import Color from 'color'

export const formatTime = (date = '') => {
  return new Date(date).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function genColor() {
  return `hsl(${(360 * Math.random()).toFixed(2)},${(25 + 70 * Math.random()).toFixed(2)}%,${(
    85 +
    10 * Math.random()
  ).toFixed(2)}%)`
}

export function getDarkerColor(col: string) {
  return Color(col).darken(0.3).string()
}

export function AddTransparency(col: string) {
  return Color(col).alpha(0.5).string()
}

export function genId() {
  return Math.random().toString(32).slice(2)
}

export const setTitle = function (str = '') {
  if (str) {
    document.title = str + ' – Skechy'
  } else {
    document.title = 'Skechy'
  }
}

export const capitalize = (str = '') => str.charAt(0).toUpperCase() + str.slice(1)

export const HOUR = 60 * 60 * 1000

export const enableAudioContext = () => {
  try {
    // @ts-ignore
    const AudioContext = window.AudioContext || window.webkitAudioContext
    const context = new AudioContext()
    context.resume()
  } catch (err) {
    console.error('could not enable audio context', err)
  }
}

const pad = (num: number) => (num < 10 ? '0' + num : num)

export const getTimeLeft = (duration: number) => {
  const seconds = Math.floor((duration / 1000) % 60)
  const minutes = Math.floor((duration / (1000 * 60)) % 60)
  const hours = Math.floor(duration / (1000 * 60 * 60))

  const chunks = [minutes, seconds]
  if (hours > 0) {
    chunks.unshift(hours)
  }
  return chunks.map(pad).join(':')
}

export const makeSafeFn = (fn: () => void) =>
  function () {
    try {
      // @ts-ignore
      return fn.apply(this, arguments)
    } catch (err) {
      console.error(err)
    }
  }

export const penColors = {
  green: '#1DAF91',
  blue: '#3598DB',
  purple: '#8D53D1',
  red: '#EA3E3E',
  orange: '#F6B15F',
  yellow: '#F3C713',
  grey: '#949599',
  black: '#2B2626',
}

export type PenColor = keyof typeof penColors

export const noteColors = ['#f7ed91', '#FCBB1C', '#FD84A1', '#6FDCD4']

export const lineVariants = {
  thin: 1,
  regular: 3,
  thick: 4,
}

export const videoClipping = {
  circle: 'circle(50% at 50% 50%)',
  diamond: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
  pentagon: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
  hexagont: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)',
  asymmetric: 'inset(1% round 15% 10% 30% 0px)',
  star: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)',
  box: 'inset(1% round 3%)',
}

export function getMousePos(event: MouseEvent, container: HTMLElement) {
  const scale =
    parseFloat(getComputedStyle(event.target as Element).getPropertyValue('--scale')) || 1
  const rect = container.getBoundingClientRect()

  const pos = {
    x: (event.clientX - rect.x) / scale,
    y: (event.clientY - rect.y) / scale,
  }
  return pos
}

export function isValidEmail(email: string) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true
  }
  return false
}
